import ForwardRef from "./help.js";
import ForwardRef$1 from "./student.js";
import ForwardRef$2 from "./unemployed.js";
import ForwardRef$3 from "./work.js";
const FiguresList = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  help: ForwardRef,
  student: ForwardRef$1,
  unemployed: ForwardRef$2,
  work: ForwardRef$3
}, Symbol.toStringTag, { value: "Module" }));
export {
  FiguresList as F,
  ForwardRef as help,
  ForwardRef$1 as student,
  ForwardRef$2 as unemployed,
  ForwardRef$3 as work
};
